/*
 * @Author: Chris 
 * @Date: 2022-07-29 14:23:37 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-09 16:26:12
 */
 
<template>
  <div class="PAGE_OUTSTYLE organization">
    <el-card class="left_card">
      <Organize ref="organize" @chooseOrg="getChooseOrganizeData"></Organize>
    </el-card>
    <el-card class="right_card">
      <Member :orgdata="orgdata"></Member>
    </el-card>
  </div>
</template>

<script>
import Organize from "../organization/components/organize.vue";
import Member from "../organization/components/member.vue";
export default {
  name: "organization",
  components: {
    Organize,
    Member,
  },
  data() {
    return {
      orgdata: null,
    };
  },
  methods: {
    /**
     * 获取选择的公司组织架构
     * */

    getChooseOrganizeData(data, name) {
      this.orgdata = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.organization {
  display: flex;
  .left_card {
    width: 25rem;
  }
  .right_card {
    flex: 1;
    margin-left: 0.5rem;
  }
}
</style>